import { css } from '@emotion/react'

export const image = css`
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
`
